import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ChangeLogDescription} from 'src/components/change-log';

import {
    entitlementRoleChangeLogStateActions,
    entitlementRoleChangeLogStateSelector,
} from '../slices/entitlement-role-change-log-state.slice';

type Props = {
    description: string,
};

export const ActionDescriptionCell = ({description}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(entitlementRoleChangeLogStateSelector);
    const query = (cacheKeys.filters?.entitlementName ?? '') as string;

    const onEntityClick = useCallback((entitlementName: string) => {
        dispatch(entitlementRoleChangeLogStateActions.setFilters({entitlementName}));
    }, [dispatch]);

    return (
        <ChangeLogDescription description={description} query={query} onEntityClick={onEntityClick}/>
    );
};
